<template>
  <div v-if="layout === 'names'" class="names">
    <WTooltip
      v-for="staff in computedTeam.visible"
      :key="staff.id"
      :position="tooltipPosition"
      size="small"
      class="staffName"
      :label="staff.title"
    >
      <span>{{ staff.shortName }}</span>
    </WTooltip>

    <WTooltip
      v-if="computedTeam.hidden.length"
      :position="tooltipPosition"
      :label="computedTeam.hidden.join('<br>')"
    >
      <span> + {{ computedTeam.hidden.length }} </span>
    </WTooltip>
  </div>

  <div v-else-if="layout === 'avatar'" class="container">
    <WTooltip
      v-for="staff in computedTeam.visible"
      :key="staff.id"
      :position="tooltipPosition"
      size="small"
      class="staff"
      :label="staff.title"
    >
      <WAvatar size="xsmall" :url="staff.profileImageUrl || staff.photoURL" />
    </WTooltip>

    <WTooltip
      v-if="computedTeam.hidden.length"
      size="small"
      :position="tooltipPosition"
      :label="computedTeam.hidden.join('<br>')"
    >
      <span class="staff avatar count">
        + {{ computedTeam.hidden.length }}
      </span>
    </WTooltip>
  </div>
</template>

<script>
import { WAvatar, WTooltip } from '@alice-health/wonderland-vue'

export default {
  name: 'CHealthcareTeam',
  components: {
    WTooltip,
    WAvatar
  },
  props: {
    team: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: 'avatar'
    },
    limit: Boolean,
    tooltipPosition: {
      type: String,
      default: 'bottom'
    }
  },
  data() {
    return {
      staffLimit: 3
    }
  },
  computed: {
    computedTeam() {
      const team = this.team.map(staff => {
        const staffName =
          staff.fullName ||
          staff.name ||
          [staff.firstName, staff.lastName].filter(Boolean).join(' ')
        const [firstName, lastName] = staffName.split(' ')
        const shortName = [firstName, lastName?.charAt(0)]
          .filter(Boolean)
          .join(' ')

        return {
          ...staff,
          staffName,
          shortName,
          title: [staffName, staff.description].filter(Boolean).join(' - ')
        }
      })

      if (this.limit) {
        return {
          visible: team.slice(0, this.staffLimit),
          hidden: team
            .slice(this.staffLimit, team.length)
            .map(staff => staff.title)
        }
      }

      return { visible: team, hidden: [] }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.names {
  @extend %caption;
  display: flex;
  gap: 4px;
}

.container {
  display: flex;
}

.staff {
  & + & {
    margin-left: -4px;
  }
}

.staffName:not(:last-child) span::after {
  content: ', ';
}

.count {
  @extend %caption;
  background: var(--sys-color-surface-background-default);
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 2px;
}
</style>
